import * as React from 'react';
import { useEffect, useState } from "react";
import { Box, Tabs, Tab, MenuItem, Select, Typography, CircularProgress } from "@mui/material";
import "../../styles/rosterTabs.css";
import RosterUpload from "./tabs/rosterUpload";
import RosterSummary from "./tabs/rosterSummary";
import { api } from "../../../../utils/axios";
import RosterTerminate from "./tabs/rosterTerminate";
import RosterRefreshBilling from "./tabs/rosterRefreshBilling";
import RosterActivateBilling from "./tabs/rosterActivateBilling";

const RosterTabs: React.FC = () => {
    const [clients, setClients] = useState<any[]>([]);
    const [selectedClientId, setSelectedClientId] = useState<string>("");
    const [selectedClientName, setSelectedClientName] = useState<string>("");
    const [tabIndex, setTabIndex] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const fetchClients = async () => {
            try {
                const response = await api.get("/clients");
                const seen = new Set();
                const uniqueClients = response.data.filter((client: any) => {
                    if (seen.has(client.client_name)) return false;
                    seen.add(client.client_name);
                    return true;
                });
                setClients(uniqueClients);

                if (uniqueClients.length > 0) {
                    setSelectedClientId(uniqueClients[0].client_id);
                    setSelectedClientName(uniqueClients[0].client_name);
                }
            } catch (error) {
                console.error("Failed to load clients", error);
            } finally {
                setLoading(false);
            }
        };
        fetchClients();
    }, []);

    const handleClientChange = (event: any) => {
        const selectedId = event.target.value;
        setSelectedClientId(selectedId);
        const found = clients.find(c => c.client_id === selectedId);
        setSelectedClientName(found?.client_name || "");
    };

    if (loading) return <CircularProgress />;

    return (
        <Box className="roster-tabs-container">
            <Box className="client-selector">
                <Typography variant="h6">Select a Client:</Typography>
                <Select
                    value={selectedClientId}
                    onChange={handleClientChange}
                    className="client-dropdown"
                >
                    {clients.map((client) => (
                        <MenuItem key={client.client_id} value={client.client_id}>
                            {client.client_name}
                        </MenuItem>
                    ))}
                </Select>
            </Box>

            <Tabs value={tabIndex} onChange={(_, newIndex) => setTabIndex(newIndex)}>
                <Tab label="Summary" />
                <Tab label="Upload" />
                <Tab label="Terminate" />
                <Tab label="Refresh Billing" />
                <Tab label="Activate Billing" />
            </Tabs>

            <Box mt={2}>
                {tabIndex === 0 && selectedClientId && (
                    <RosterSummary clientId={selectedClientId} />
                )}
                {tabIndex === 1 && selectedClientId && (
                    <RosterUpload clientId={selectedClientId} clientName={selectedClientName} />
                )}
                {tabIndex === 2 && selectedClientId && (
                    <RosterTerminate clientId={selectedClientId} />
                )}
                {tabIndex === 3 && selectedClientId && (
                    <RosterRefreshBilling clientId={selectedClientId} />
                )}
                {tabIndex === 4 && selectedClientId && (
                    <RosterActivateBilling clientId={selectedClientId} />
                )}
            </Box>

        </Box>
    );
};

export default RosterTabs;
